import { render, staticRenderFns } from "./presell_order.vue?vue&type=template&id=2d813788&scoped=true"
import script from "./presell_order.vue?vue&type=script&lang=js"
export * from "./presell_order.vue?vue&type=script&lang=js"
import style0 from "./presell_order.vue?vue&type=style&index=0&id=2d813788&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d813788",
  null
  
)

export default component.exports